import {
  ResendConfirmUserEmailPayload,
  ResendConfirmUserEmailResponse,
  resendConfirmUserEmail,
} from 'app/api/resendConfirmUserEmail'
import { AxiosError } from 'axios'
import { ApiError } from 'EstraSponsor'
import { useMutation, UseMutationResult } from 'react-query'

export const useResendConfirmUserEmail = (): UseMutationResult<
  ResendConfirmUserEmailResponse,
  AxiosError<ApiError>,
  ResendConfirmUserEmailPayload
> => {
  {
    return useMutation(resendConfirmUserEmail)
  }
}
